var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__list_item",class:{ active: _vm.active },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(" "+_vm._s(_vm.filter.title || _vm.$t(`filters.${_vm.$vnode.key}`))+" ")]),(_vm.numberOfFilters)?_c('div',{staticClass:"box filter--count"},[_vm._v(" "+_vm._s(_vm.numberOfFilters)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }